import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import API_BASE_URL from 'Components/API'
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { ReactComponent as ExcelIcon } from "Assets/icons/excel.svg";
import { ReactComponent as PdfIcon } from "Assets/icons/pdf.svg";
import { ReactComponent as AttachIcon } from "Assets/icons/attach.svg";
import { ReactComponent as EyeIcon } from "Assets/icons/eye.svg";
import FileDownload from "Components/FileDownload";

const SupplyStatementsList = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 4,
    });
    const fileUrl = `${API_BASE_URL}/Listing/GetSupplyStatementsAttachment`;
    const viewPdf = async (attachmentId, fileUrl, contentType) => {
        try {
            const response = await fetch(`${fileUrl}/${attachmentId}`);
            const data = await response.json();

            if (!data.results || !data.results[0]?.fileContent) {
                console.error("No PDF content returned");
                return;
            }
            const fileContentBase64 = data.results[0].fileContent;
            const byteCharacters = atob(fileContentBase64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                const slice = byteCharacters.slice(offset, offset + 1024);
                const byteNumbers = Array.from(slice).map(c => c.charCodeAt(0));
                byteArrays.push(new Uint8Array(byteNumbers));
            }

            const blob = new Blob(byteArrays, { type: contentType || "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, "_blank");
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

        } catch (err) {
            console.error("Failed to view PDF:", err);
        }
    };
    const fetchData = async () => {
        setIsLoaded(true);
        const url = new URL(
            `${API_BASE_URL}/Listing/GetSupplyStatements`
        );
        url.searchParams.set(
            'start',
            `${pagination.pageIndex * pagination.pageSize}`,
        );
        url.searchParams.set('PageNumber', `${pagination.pageIndex + 1}`)
        url.searchParams.set('PageSize', `${pagination.pageSize}`);

        try {
            const response = await fetch(url.href);
            const json = await response.json();
            setData(json.results || []);
        } catch (error) {
            console.error(error);
            return;
        }
        setIsLoaded(true);
    };
    useEffect(() => {
            fetchData();
    }, [currentLang]);
    return (
        <div className="megaMenuContent">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <strong className="fw-bold"> {t("latestSupplyStatements")}:</strong>
                <a href="/Listing/SupplyStatementsList" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                    {t("viewAllSupplyStatements")}
                    <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                        {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                    </span>
                </a>
            </div>
            {data.map((item, index) => (
                <div key={index } className="SupplyStatementsList d-flex w-100 align-items-center justify-content-between mb-3">
                    <a href="/" className="text-blue fw-bolder supplyStateInstrument">
                        {item.instrumentName }
                    </a>
                    <span className="supplyStateSupplierSame">{item.supplierName}</span>
                    <span>-</span>
                    <div className="d-flex supplyStateDate">
                        <span>{t('submission_time') }: </span>
                        <span className="text-blue mx-2"> {item.admissionDate} </span>
                        {/*<span className="text-blue">{item.admissionDate}</span>*/}
                    </div>
                    <div className="d-flex supplyStateActions">
                        <EyeIcon
                            width={20}
                            height={20}
                            style={{ cursor: "pointer", marginRight: "10px" }}
                            onClick={() =>
                                viewPdf(
                                    item.id,
                                    fileUrl,
                                    item.contentType
                                )
                            }
                        />
                        <FileDownload
                            key={item.id}
                            attachmentId={item.id}
                            fileUrl={fileUrl}
                            fileSize={item.fileSize}
                            contentType={item.contentType}
                            fileName={item.fileName}
                        />                    
                    </div>
                </div>
            ))}           
        </div>
    );
};

export default SupplyStatementsList;
